<template>
  <v-snackbar v-model="showNotify"
              bottom right
              :color="color"
              multi-line
              @input="closeNotify"
              :timeout=5000
              :width="width"
              >
    <div class="d-flex align-center justify-space-between" >
      {{ text }}
        <div v-if="showDetails">
          <v-btn
            icon dark
            @click="detailsShowed =! detailsShowed"
            :class="[{'notify-btn-details':detailsShowed}]"
            v-if="isError"
          >
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>

          <v-btn icon dark @click="closeNotify">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-expand-transition v-if="showDetails">
      <div v-if="showDetails" v-show="detailsShowed">
        <div>
          {{$t("messages.requestId")}}: {{requestId}}
        </div>
        <div>
          {{$t("messages.eventTime")}}: {{dateTime}}
        </div>
      </div>
    </v-expand-transition>
  </v-snackbar>
</template>

<script>
import { notificationApi } from '@/api/notificationApi'
import moment from 'moment'
export default {
  name: 'Notify',
  data: () => ({
    showNotify: false,
    isError: false,
    detailsShowed: false
  }),
  watch: {
    notify(val) {
      if (val) {
        this.showNotify = true
      }
    }
  },
  computed: {
    notify () {
      const notify = this.$store.state.general.notify
      const error = this.$store.state.general.error
      this.setErrorNotify(error)
      return notify || error
    },
    width () {
      return this.isError ? 500 : undefined
    },
    color () {
      if (this.isError) {
        return 'error'
      }
      return this.notify && this.notify.color
        ? this.notify.color
        : 'secondary'
    },
    text () {
      return this.notify && this.notify.text
        ? this.notify.text
        : undefined
    },
    dateTime () {
      let dateTime = this.notify?.dateTime
      if (!dateTime) {
        return ''
      }
      moment.locale(this.$i18n.locale)
      return `${moment().format('L')}:${moment(dateTime).format('LTS')}`
    },
    requestId () {
      return this.notify?.requestId
    },
    showDetails () {
      return this.notify && this.notify.showDetails
    }
  },
  methods: {
    closeNotify () {
      this.showNotify = false
      notificationApi.hide()
      notificationApi.showError(null)
    },
    inputNotify () {
      // console.log(event)
    },
    setErrorNotify(error) {
      this.isError = error ? true : false
    }
  }
}
</script>
<style>
.notify-btn-details {
  transform: rotate(180deg)
}
</style>
